module.exports = __webpack_public_path__ + "static/img/mark.3d65e5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mark.jpg
// module id = aUfA
// module chunks = 32